import { constants } from '../constant/constant';
import { httpservice } from '../services';
import { dateFormat } from '../helper/StringUtils';
import { RE_SELLER } from '../constant/actionTypes';

export const getResellerList = () => (dispatch) => {
  const query = `${constants.API.RE_SELLER}`.replace('-', '');
  dispatch({
    payload: [],
    type: RE_SELLER.GET.INITIATE,
  });

  return httpservice()
    .get(query)
    .then((response) => {
      let rows = [];
      let count = 0;

      if (response.data.response.length) {
        rows = response.data.response;
        count = response.data.response.length;
      } else {
        rows = response.data.response.rows;
        count = response.data.response.count;
      }

      const responseData = rows && rows.length ? rows.map((data) => (
        {
          ...data,
          name: `${data.firstName} ${data.lastName}`,
          createdBy: data.creator ? `${data.creator.firstName} ${data.creator.lastName}` : 'admin',
          createdAt: dateFormat(data.createdAt),
        }
      )) : [];

      dispatch({
        payload: {
          data: responseData,
          count,
        },
        type: RE_SELLER.GET.SUCCESS,
      });

      return responseData;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: RE_SELLER.GET.ERROR,
      });
    });
};

export const doCreateReSeller = (formData) => httpservice()
  .post(`${constants.API.RE_SELLER}`, formData)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const doUpdateReSeller = (formData) => httpservice()
  .put(`${constants.API.RE_SELLER}/${formData.id}`, formData)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const doDeleteReSeller = (id) => httpservice()
  .delete(`${constants.API.RE_SELLER}/${id}`)
  .then((response) => response.data)
  .catch((error) => error.response.data);
